// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Panel */
.panel {
  background: #ffffff; /* White background */
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  padding: 10px;
  margin-bottom: 10px;
}

/* Action buttons: keep label on a single row */
.btn-configure {
  white-space: nowrap;
}

/* Row */
.row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

/* Headings */
.panel h3 {
  font-family: "Gotham", sans-serif;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #343a40; /* Dark color for better readability */
}

/* Form group */
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.col-4 {
  flex: 1;
  padding: 0 10px;
}

/* Labels */
label {
  font-family: "Gotham", sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #495057;
  margin-bottom: 5px;
}

/* Dropdown */
p-dropdown {
  width: 100%;
}

/* Buttons */
.btn-primary {
  background: #0B2D71;
  color: #fff;
  border: none;
  border-radius: 0;
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
  font-size: 0.88em;
  cursor: pointer;
}

.btn-primary:hover {
  background: #0066B2;
}

.btn-primary:disabled {
  background: #d6d8db;
  cursor: not-allowed;
}

/* Sync comments */
.sync-comment {
  font-family: "Gotham", sans-serif;
  font-size: 12px;
  color: #868e96;
  margin-top: 10px;
}

/* Flex container */
.flex {
  display: flex;
  flex-direction: column;
  gap: 1em;
}

/* Additional styles */
.strong {
  font-weight: bold;
}

span {
  display: block;
}

/* Refresh link */
.refresh-link {
  font-family: "Gotham", sans-serif;
  font-size: 14px;
  color: #007bff;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.refresh-link:hover {
  text-decoration: underline;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.align-items-center {
  align-items: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

/* Input Styles */
#WBSGroupCheck {
  transform: scale(1.2);
}

.custom-dialog .dialog-message {
  font-size: 1.2em;
  font-weight: 500;
  margin-bottom: 1em;
  text-align: center;
}

.custom-dialog .p-button-warning {
  background-color: #ff9800;
  border-color: #ff9800;
  color: #fff;
}

.custom-dialog .p-button-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

.custom-button {
  font-size: 1em;
  margin-right: 10px;
}

.custom-dialog .ui-dialog-footer {
  display: flex;
  justify-content: center;
}

.WbsAccordion {
  margin: 10px;
}

.JobAccordion {
  margin: 8px;
}

:host ::ng-deep .p-accordionpanel {
  margin-bottom: 10px;
}

:host ::ng-deep .p-accordioncontent-content {
  padding: 10px !important;
  /* Contain wide grids (activity tables) so they scroll within the
     panel instead of overflowing the page horizontally. */
  overflow-x: auto;
  /* Allow this grid/flex item to shrink below its content size so the
     overflow scroll actually engages instead of widening the panel. */
  min-width: 0;
}

/* The content wrapper is a CSS grid item (.p-motion); grid items default
   to min-width:auto which forces the panel to grow to the table width.
   Reset it so the inner content can scroll horizontally. */
:host ::ng-deep .p-accordioncontent-wrapper,
:host ::ng-deep .p-accordioncontent .p-motion {
  min-width: 0;
}

#expandButton {
  border-radius: 0 !important; /* Remove rounded corners */
  background: #0B2D71 !important; /* Primary blue background */
  color: #ffffff !important; /* White text */
  border: none !important; /* Remove border */
  padding: 8px 16px !important; /* Add consistent padding */
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif" !important; /* Font family */
  font-size: 14px !important; /* Font size */
  cursor: pointer !important; /* Pointer cursor */
  transition: background-color 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */
}

#expandButton:hover {
  background: #0066B2 !important; /* Darker blue on hover */
  color: #ffffff !important; /* Ensure white text on hover */
}

#WBSGroupCheck {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  margin-right: 20px;
}

:host ::ng-deep .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader {
  background: #0B2D71;
  color: #ffffff;
}

/* Top-level stripes (blueTab) render gray in both collapsed and expanded
   states, overriding the default active dark-blue header. */
:host ::ng-deep .blueTab > .p-accordionheader {
  background: #d3d5d8 !important;
  color: #0B2D71 !important;
}

:host ::ng-deep .blueTab > .p-accordionheader:hover {
  background: #c7cacd !important;
  color: #0B2D71 !important;
}

:host ::ng-deep .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader:hover {
  background: #0066B2;
  color: #ffffff;
}

:host ::ng-deep .p-accordionheader:has(.p-accordionheader-toggle-icon.icon-start) {
  background: #dadcde;
  justify-content: flex-start;
  gap: var(--p-accordion-header-padding);
}

:host ::ng-deep .p-accordionpanel:not(.p-accordionpanel-active):not(.p-disabled) > .p-accordionheader:hover {
  background: #e8e9eb;
  color: var(--p-accordion-header-hover-color);
}

:host ::ng-deep .p-accordionheader {
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 10px 10px;
  color: var(--p-accordion-header-color);
  background: var(--p-accordion-header-background);
  border-style: solid;
  border-width: var(--p-accordion-header-border-width);
  border-color: var(--p-accordion-header-border-color);
  font-weight: var(--p-accordion-header-font-weight);
  border-radius: var(--p-accordion-header-border-radius);
  transition: background var(--p-accordion-transition-duration);
  outline-color: transparent;
  position: relative;
  overflow: hidden;
  flex-direction: row;
}

:host ::ng-deep .custom-save-button {
  all: unset; /* Reset all PrimeNG styles */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0B2D71 !important; /* Primary blue background 0066B2 */
  color: #fff !important; /* White text */
  border: none !important; /* No border */
  padding: 10px 20px !important; /* Add padding */
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif" !important; /* Font family */
  font-size: 14px !important; /* Font size */
  cursor: pointer !important; /* Pointer cursor */
  transition: background 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */
}

:host ::ng-deep .custom-save-button:hover {
  background: #0066B2 !important; /* Darker blue on hover */
  color: #fff !important; /* Ensure white text on hover */
}

:host ::ng-deep .custom-save-button:disabled {
  background: #0B2D71 !important; /* Gray background for disabled state */
  color: #6c757d !important; /* Muted text color */
  cursor: not-allowed !important; /* Disabled cursor */
  box-shadow: none !important; /* Remove shadow for disabled state */
}`, "",{"version":3,"sources":["webpack://./src/pages/synchronization/synchronization.component.scss"],"names":[],"mappings":"AAAA,UAAA;AACA;EACE,mBAAA,EAAA,qBAAA;EACA,mBAAA,EAAA,oBAAA;EACA,wCAAA,EAAA,kBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA,+CAAA;AACA;EACE,mBAAA;AACF;;AAEA,QAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA,aAAA;AACA;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA,EAAA,sCAAA;AACF;;AAEA,eAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,eAAA;AACF;;AAEA,WAAA;AACA;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA,aAAA;AACA;EACE,WAAA;AACF;;AAEA,YAAA;AACA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAEA,+EAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAIA;EACE,mBAAA;AADF;;AAKA;EACE,mBAAA;EACA,mBAAA;AAFF;;AAQA,kBAAA;AACA;EACE,iCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AALF;;AAQA,mBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AALF;;AAQA,sBAAA;AACA;EACE,iBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA,iBAAA;AACC;EACC,iCAAA;EACA,eAAA;EACA,cAAA;EAAgB,eAAA;EAChB,aAAA;EAAe,mBAAA;AAHjB;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAIA;EACE,8BAAA;AADF;;AAGA;EACE,yCAAA;AAAF;;AAEA;EACE,+BAAA;AACF;;AACA,iBAAA;AACA;EACE,qBAAA;AAEF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AAAF;;AAGA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;AAAF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,wBAAA;EACA;0DAAA;EAEA,gBAAA;EACA;sEAAA;EAEA,YAAA;AADF;;AAIA;;2DAAA;AAGA;;EAEE,YAAA;AADF;;AAIA;EACE,2BAAA,EAAA,2BAAA;EACA,8BAAA,EAAA,4BAAA;EACA,yBAAA,EAAA,eAAA;EACA,uBAAA,EAAA,kBAAA;EACA,4BAAA,EAAA,2BAAA;EACA,0FAAA,EAAA,gBAAA;EACA,0BAAA,EAAA,cAAA;EACA,0BAAA,EAAA,mBAAA;EACA,sEAAA,EAAA,uCAAA;AADF;;AAIA;EACE,8BAAA,EAAA,yBAAA;EACA,yBAAA,EAAA,+BAAA;AADF;;AAIA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AADA;;AAIA;EACE,mBAAA;EACA,cAAA;AADF;;AAIA;4DAAA;AAEA;EACE,8BAAA;EACA,yBAAA;AADF;;AAIA;EACE,8BAAA;EACA,yBAAA;AADF;;AAIA;EACE,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,2BAAA;EACA,sCAAA;AADF;;AAIA;EACE,mBAAA;EACA,4CAAA;AADF;;AAKA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,gDAAA;EACA,mBAAA;EACA,oDAAA;EACA,oDAAA;EACA,kDAAA;EACA,sDAAA;EACA,6DAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,UAAA,EAAA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA,EAAA,mCAAA;EACA,sBAAA,EAAA,eAAA;EACA,uBAAA,EAAA,cAAA;EAEA,6BAAA,EAAA,gBAAA;EACA,0FAAA,EAAA,gBAAA;EACA,0BAAA,EAAA,cAAA;EACA,0BAAA,EAAA,mBAAA;EACA,gEAAA,EAAA,uCAAA;AAHF;;AAMA;EACE,8BAAA,EAAA,yBAAA;EACA,sBAAA,EAAA,+BAAA;AAHF;;AAQA;EACE,8BAAA,EAAA,uCAAA;EACA,yBAAA,EAAA,qBAAA;EACA,8BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,qCAAA;AALF","sourcesContent":["/* Panel */\r\n.panel {\r\n  background: #ffffff; /* White background */\r\n  border-radius: 10px; /* Rounded corners */\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow */\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Action buttons: keep label on a single row */\r\n.btn-configure {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Row */\r\n.row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Headings */\r\n.panel h3 {\r\n  font-family: 'Gotham', sans-serif;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n  color: #343a40; /* Dark color for better readability */\r\n}\r\n\r\n/* Form group */\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.col-4 {\r\n  flex: 1;\r\n  padding: 0 10px;\r\n}\r\n\r\n/* Labels */\r\nlabel {\r\n  font-family: 'Gotham', sans-serif;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #495057;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n/* Dropdown */\r\np-dropdown {\r\n  width: 100%;\r\n}\r\n\r\n/* Buttons */\r\n.btn-primary {\r\n  background:#0B2D71 ;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 0;\r\n \r\n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';\r\n  font-size: 0.88em;\r\n  cursor: pointer;\r\n // transition: background 0.3s, transform 0.3s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background:  #0066B2;\r\n // transform: translateY(-2px); /* Lift effect on hover */\r\n}\r\n\r\n.btn-primary:disabled {\r\n  background: #d6d8db;\r\n  cursor: not-allowed;\r\n}\r\n\r\n// .btn-primary:active {\r\n//  // box-shadow: 0 2px #0056b3, 0 0 15px 3px rgba(0, 123, 255, 0.7);\r\n// }\r\n/* Sync comments */\r\n.sync-comment {\r\n  font-family: 'Gotham', sans-serif;\r\n  font-size: 12px;\r\n  color: #868e96;\r\n  margin-top: 10px;\r\n}\r\n\r\n/* Flex container */\r\n.flex {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1em;\r\n}\r\n\r\n/* Additional styles */\r\n.strong {\r\n  font-weight: bold;\r\n}\r\n\r\nspan {\r\n  display: block;\r\n}\r\n\r\n/* Refresh link */\r\n .refresh-link { \r\n  font-family: 'Gotham', sans-serif; \r\n  font-size: 14px; \r\n  color: #007bff; cursor: pointer; \r\n  display: flex; align-items: center; \r\n} \r\n.refresh-link:hover { \r\n  text-decoration: underline; \r\n}\r\n//--------------------------------------------------------------------------\r\n.mb-3 { \r\n  margin-bottom: 1rem !important; \r\n} \r\n.align-items-center { \r\n  align-items: center !important; \r\n} \r\n.justify-content-between { \r\n  justify-content: space-between !important; \r\n} \r\n.me-2 { \r\n  margin-right: 0.5rem !important\r\n}\r\n/* Input Styles */ \r\n#WBSGroupCheck { \r\n  transform: scale(1.2); \r\n}\r\n\r\n\r\n// alert button code\r\n.custom-dialog .dialog-message {\r\n  font-size: 1.2em;\r\n  font-weight: 500;\r\n  margin-bottom: 1em;\r\n  text-align: center;\r\n}\r\n\r\n.custom-dialog .p-button-warning {\r\n  background-color: #ff9800;\r\n  border-color: #ff9800;\r\n  color: #fff;\r\n}\r\n\r\n.custom-dialog .p-button-primary {\r\n  background-color: #007bff;\r\n  border-color: #007bff;\r\n  color: #fff;\r\n}\r\n\r\n.custom-button {\r\n  font-size: 1em;\r\n  margin-right: 10px;\r\n}\r\n\r\n.custom-dialog .ui-dialog-footer {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n/////////////////////////////////////////////////////\r\n\r\n.WbsAccordion {\r\n  margin: 10px;\r\n}\r\n\r\n.JobAccordion {\r\n  margin: 8px;\r\n}\r\n\r\n:host ::ng-deep .p-accordionpanel {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n:host ::ng-deep .p-accordioncontent-content {\r\n  padding: 10px !important;\r\n  /* Contain wide grids (activity tables) so they scroll within the\r\n     panel instead of overflowing the page horizontally. */\r\n  overflow-x: auto;\r\n  /* Allow this grid/flex item to shrink below its content size so the\r\n     overflow scroll actually engages instead of widening the panel. */\r\n  min-width: 0;\r\n}\r\n\r\n/* The content wrapper is a CSS grid item (.p-motion); grid items default\r\n   to min-width:auto which forces the panel to grow to the table width.\r\n   Reset it so the inner content can scroll horizontally. */\r\n:host ::ng-deep .p-accordioncontent-wrapper,\r\n:host ::ng-deep .p-accordioncontent .p-motion {\r\n  min-width: 0;\r\n}\r\n\r\n#expandButton {\r\n  border-radius: 0 !important; /* Remove rounded corners */\r\n  background: #0B2D71 !important; /* Primary blue background */\r\n  color: #ffffff !important; /* White text */\r\n  border: none !important; /* Remove border */\r\n  padding: 8px 16px !important; /* Add consistent padding */\r\n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif' !important; /* Font family */\r\n  font-size: 14px !important; /* Font size */\r\n  cursor: pointer !important; /* Pointer cursor */\r\n  transition: background-color 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */\r\n}\r\n\r\n#expandButton:hover {\r\n  background: #0066B2 !important; /* Darker blue on hover */\r\n  color: #ffffff !important; /* Ensure white text on hover */\r\n}\r\n\r\n#WBSGroupCheck {\r\nwidth: 20px;\r\nheight: 20px;\r\nmargin-left: 10px;\r\nmargin-right: 20px;\r\n}\r\n\r\n:host ::ng-deep .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader {\r\n  background: #0B2D71;\r\n  color: #ffffff;\r\n}\r\n\r\n/* Top-level stripes (blueTab) render gray in both collapsed and expanded\r\n   states, overriding the default active dark-blue header. */\r\n:host ::ng-deep .blueTab > .p-accordionheader {\r\n  background: #d3d5d8 !important;\r\n  color: #0B2D71 !important;\r\n}\r\n\r\n:host ::ng-deep .blueTab > .p-accordionheader:hover {\r\n  background: #c7cacd !important;\r\n  color: #0B2D71 !important;\r\n}\r\n\r\n:host ::ng-deep .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader:hover {\r\n  background:  #0066B2;\r\n  color: #ffffff;\r\n}\r\n\r\n:host ::ng-deep .p-accordionheader:has(.p-accordionheader-toggle-icon.icon-start) {\r\n  background: #dadcde;\r\n  justify-content: flex-start;\r\n  gap: var(--p-accordion-header-padding);\r\n}\r\n\r\n:host ::ng-deep .p-accordionpanel:not(.p-accordionpanel-active):not(.p-disabled) > .p-accordionheader:hover {\r\n  background: #e8e9eb;\r\n  color: var(--p-accordion-header-hover-color);\r\n}\r\n\r\n\r\n:host ::ng-deep .p-accordionheader {\r\n  all: unset;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 10px 10px 10px;\r\n  color: var(--p-accordion-header-color);\r\n  background: var(--p-accordion-header-background);\r\n  border-style: solid;\r\n  border-width: var(--p-accordion-header-border-width);\r\n  border-color: var(--p-accordion-header-border-color);\r\n  font-weight: var(--p-accordion-header-font-weight);\r\n  border-radius: var(--p-accordion-header-border-radius);\r\n  transition: background var(--p-accordion-transition-duration);\r\n  outline-color: transparent;\r\n  position: relative;\r\n  overflow: hidden;\r\n  flex-direction: row;\r\n}\r\n\r\n:host ::ng-deep .custom-save-button {\r\n  all: unset; /* Reset all PrimeNG styles */\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #0B2D71   !important; /* Primary blue background 0066B2 */\r\n  color: #fff !important; /* White text */\r\n  border: none !important; /* No border */\r\n  //border-radius: 4px !important; /* Rounded corners */\r\n  padding: 10px 20px !important; /* Add padding */\r\n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif' !important; /* Font family */\r\n  font-size: 14px !important; /* Font size */\r\n  cursor: pointer !important; /* Pointer cursor */\r\n  transition: background 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */\r\n}\r\n\r\n:host ::ng-deep .custom-save-button:hover {\r\n  background: #0066B2 !important; /* Darker blue on hover */\r\n  color: #fff !important; /* Ensure white text on hover */\r\n  //transform: translateY(-2px) !important; /* Slight lift effect on hover */\r\n  //box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important; /* Add shadow on hover */\r\n}\r\n\r\n:host ::ng-deep .custom-save-button:disabled {\r\n  background: #0B2D71 !important; /* Gray background for disabled state */\r\n  color: #6c757d !important; /* Muted text color */\r\n  cursor: not-allowed !important; /* Disabled cursor */\r\n  box-shadow: none !important; /* Remove shadow for disabled state */\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
